import { useState } from 'react';

const faqItems = [
  {
    q: '予約なしで利用できますか？',
    a: '継続利用の会員さまの場合、予約なしでお好きな席をご利用いただけます。一時利用の場合、事前に専用のサイトから予約いただく必要があります。',
  },
  {
    q: '予約時間の前に入室できますか？',
    a: '予約時間の5分前から入室可能です。',
  },
  {
    q: 'コピー機やプリンターは使えますか？',
    a: '現在準備中です。',
  },
  {
    q: '途中退室できますか？',
    a: 'ご利用可能な時間内であれば、何度でも途中退室・再入室ができます。',
  },
  {
    q: 'オンライン会議（Webミーティング）はできますか？',
    a: '会議室、個人ブース内で可能です。ラウンジや作業エリアでオンライン会議を行う場合は、イヤホンマイクなどを使用し、周囲の方の迷惑にならないようご配慮ください。なお、集中エリアでは会話禁止とさせていただいております。',
  },
  {
    q: '個室は使えますか？',
    a: '継続契約の方は会議室と個人ブースが利用可能です。個室を占有するタイプのプランはございません。都度ご予約と、退室時の片付けをお願いします。',
  },
  {
    q: 'MeVER Chairはどのモデルが体験できますか？',
    a: 'コワーキングスペース by favy（新宿）では、MeVER Chairの複数モデルを設置しています。実際に座り比べて、お気に入りの一脚を見つけてください。',
  },
  {
    q: 'MeVER Chair体験予約はどのようにすればいいですか？',
    a: '体験予約ページ（appointment.mever.design）から、ご希望の日時を選択してご予約いただけます。予約は無料で、当日はスタッフがMeVER Chairの特徴や使い方をご案内いたします。',
  },
  {
    q: '体験予約は無料ですか？別途コワーキング利用料はかかりますか？',
    a: '体験予約自体は無料です。コワーキングスペースのご利用にはドロップイン料金（550円/30分〜）または1Dayプラン（3,300円）が別途必要となります。体験予約と合わせてドロップイン予約もお済ませいただくとスムーズです。',
  },
  {
    q: '体験予約のキャンセルや日時変更はできますか？',
    a: 'はい、予約確認メールに記載のリンクからキャンセル・日時変更が可能です。当日のキャンセルも受け付けておりますが、できるだけ早めにご連絡いただけると助かります。',
  },
];

export default function CoworkingFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(prev => (prev === index ? null : index));
  };

  return (
    <section
      className="py-16 sm:py-24 md:py-32 bg-[#FAF8F5]"
      aria-labelledby="faq-heading"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16">
          <span className="inline-block px-3 py-1.5 bg-emerald-500/10 text-emerald-600 text-xs tracking-[0.15em] rounded-full mb-4 sm:mb-6">
            FAQ
          </span>
          <h2
            id="faq-heading"
            className="text-3xl sm:text-4xl md:text-5xl font-extralight text-black mb-3 sm:mb-4 tracking-[0.1em]"
          >
            よくある質問
          </h2>
        </div>

        <div className="space-y-3" role="list">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-sm"
              role="listitem"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between px-5 sm:px-6 py-4 sm:py-5 text-left cursor-pointer"
                aria-expanded={openIndex === index}
              >
                <span className="text-sm sm:text-base font-light text-black tracking-wide pr-4">
                  {item.q}
                </span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-lg text-black/40 transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                    aria-hidden="true"
                  ></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 sm:px-6 pb-4 sm:pb-5">
                  <p className="text-sm text-black/60 font-extralight leading-relaxed tracking-wide">
                    {item.a}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
